// Copyright (c) Move Closer 2022.

import gql from 'graphql-tag'

import { QueryRegistry } from '../../../contexts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const authQueries: QueryRegistry = {
  createUserMutation: {
    type: 'mutation',
    query: gql`
      mutation($firstName: String, $lastName: String,$password: String!,$email: String!, $subscribeToNews: Boolean!) {
        createCustomer(
          input: {
            firstname: $firstName
            lastname: $lastName
            email: $email
            password: $password
            is_subscribed: $subscribeToNews
          }
        )  {
          customer {
            firstname
            lastname
            email
            date_of_birth
            is_subscribed
          }
        }
      }`,
    meta: {
      noAuth: true
    }
  },
  loginMutation: {
    type: 'mutation',
    query: gql`
      mutation($email: String!, $password: String!) {
        generateCustomerToken(email: $email, password: $password) {
          token
        }
      }
    `,
    meta: {
      noAuth: true
    }
  },
  logoutMutation: {
    type: 'mutation',
    query: gql`
        mutation {
            revokeCustomerToken {
                result
            }
        }
    `,
    meta: {
      noAuth: false
    }
  },
  requestPasswordMutation: {
    type: 'mutation',
    query: gql`
      mutation($email: String!) {
        requestPasswordResetEmail(email: $email)
      }`,
    meta: {
      noAuth: true
    }
  },
  requestResetPasswordMutation: {
    type: 'mutation',
    query: gql`
      mutation($email: String!, $resetPasswordToken: String!, $newPassword: String!) {
        resetPassword(
          email: $email,
          resetPasswordToken: $resetPasswordToken,
          newPassword: $newPassword
        )
      }`,
    meta: {
      noAuth: true
    }
  }
}
